import { Field, NumericInput, RadioGroup, TextInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { MaterialDryMassObtainedBy } from 'Components/Worksheets/WashWorksheet/types';
import { Guid } from 'Lib/Guid';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import externalTestMethods from '../../../../ExternalTestMethods';

const DryMassImportSection = withInjectedProps(({ createWorksheetSelector }: IWorksheetComponent) => {
  const importedMcId = useSelector(
    createWorksheetSelector!('Masses.AssociatedInitialMoistureContent.ImportedTest.Id')
  ) as Guid;
  const importedDryMass: boolean = useSelector(
    pipe(createWorksheetSelector!('Masses.MaterialDryMassObtainedBy'), (m) => m === MaterialDryMassObtainedBy.Imported)
  );
  return (
    <>
      <ListFieldSection heading="Initial Material Dry Mass">
        <Field
          confirm={importedDryMass}
          input={<RadioGroup />}
          confirmTitle="Water Content Deletion"
          confirmText="Are you sure you want to delete existing water content data?"
          confirmButtonText="Delete"
          name="Masses.MaterialDryMassObtainedBy"
          label="Material Dry Mass Obtained by"
          options={[
            { label: 'Measurement as part of this test', value: MaterialDryMassObtainedBy.Measured },
            { label: 'Imported from another test', value: MaterialDryMassObtainedBy.Imported },
          ]}
        />
      </ListFieldSection>
      <WorksheetAssociatedTestSection
        associatedTestModel={{
          autoImported: true,
          imported: {
            importedTestResults: (
              <ListFieldSection>
                <Field input={<TextOutput />} label="Tare ID" name="Masses.InitialTareID" emph />
                <Field input={<TextOutput />} label="Tare Mass" name="Masses.InitialTareMass" emph />
                <Field input={<TextOutput />} label="Dry Mass" name="Masses.InitialDryMass" emph />
              </ListFieldSection>
            ),
            importModel: {
              Id: importedMcId,
            },
          },
          external: {
            testMethods: [externalTestMethods.moistureContent.ASTM_D2216],
            permitOtherTestMethods: true,
            externalTestResults: (
              <ListFieldSection>
                <Field
                  input={<TextInput />}
                  name="Masses.AssociatedInitialMoistureContent.ExternalTest.Results.InitialTareID"
                  label="Tare ID"
                  maxLength={20}
                  emph
                />
                <Field
                  input={<NumericInput />}
                  name="Masses.AssociatedInitialMoistureContent.ExternalTest.Results.InitialTareMass"
                  label="Tare Mass"
                  emph
                />
                <Field
                  input={<NumericInput />}
                  name="Masses.AssociatedInitialMoistureContent.ExternalTest.Results.InitialDryMass"
                  label="Dry Mass"
                  emph
                />
              </ListFieldSection>
            ),
          },
        }}
        label="Initial Dry Mass"
        name="Masses.AssociatedInitialMoistureContent"
        testType="Moisture Content"
      />
    </>
  );
});

export { DryMassImportSection };
